import { DogBreed, UserAnswers, BreedMatch, QuizQuestion } from '@/types/dogs';

// Use environment variables for API URL
const API_BASE_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3000';

export async function getAllBreeds(): Promise<DogBreed[]> {
  const response = await fetch(`${API_BASE_URL}/api/dogs`);
  if (!response.ok) {
    throw new Error('Failed to fetch breeds');
  }
  return response.json();
}

export async function getBreed(breedId: string): Promise<DogBreed> {
  const response = await fetch(`${API_BASE_URL}/api/dogs/${breedId}`);
  if (!response.ok) {
    throw new Error('Failed to fetch breed details');
  }
  return response.json();
}

export async function getQuizQuestions(): Promise<QuizQuestion[]> {
  const response = await fetch(`${API_BASE_URL}/api/quiz/questions`);
  if (!response.ok) {
    throw new Error('Failed to fetch quiz questions');
  }
  return response.json();
}

export async function submitQuizAnswers(answers: UserAnswers): Promise<BreedMatch[]> {
  const response = await fetch(`${API_BASE_URL}/api/quiz/match`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(answers),
  });
  
  if (!response.ok) {
    throw new Error('Failed to process quiz answers');
  }
  
  return response.json();
}

interface ContactFormData {
  name: string;
  email: string;
  message: string;
  captchaToken: string;
}

export async function submitContactForm(formData: ContactFormData) {
  const response = await fetch('/api/contact', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to submit contact form');
  }

  return response.json();
} 